import { ENABLE_AMENDMENT_V2_JOURNEY, ENABLE_ANNUAL_REPORT_V2_JOURNEY } from '#client/constants/experimentsFlags';

/**
 * This configuration determines when coupons should be enabled for users based on their
 * entitlements and the product they are viewing.
 *
 * How it works:
 * - Each rule specifies an entitlement and the products where coupons should be enabled
 * - If a user has the specified entitlement AND is viewing one of the enabled products,
 *   then coupons will be shown and applied
 * - If either condition is false, coupons are not displayed
 *
 * Usage:
 * - Used by shouldEnableCoupons() helper function src/pages/ProductLanding/components/HeroSection/components/BuyBox/coupons/utils.js
 * - Consumed by BuyBoxContext to determine if coupons should be applied
 *
 * To add new rules:
 * 1. Add a new object to the array below
 * 2. Specify the entitlement string (must match actual entitlement names)
 * 3. List all products where coupons should be enabled for that entitlement
 */
export const ENABLED_COUPONS_CONFIG = [
  {
    entitlement: 'worry_free_service',
    products: ['wfg_initial_report', 'llc_amendment', 'llc_annual_report']
  },
  {
    entitlement: 'worry_free_service_advanced',
    products: ['wfg_initial_report', 'llc_amendment', 'llc_annual_report', 'standard_good_standing']
  },
  {
    entitlement: 'worry_free_service_basic',
    products: ['wfg_initial_report', 'llc_amendment', 'llc_annual_report']
  }
];

/**
 * Configuration for product-specific flag requirements for coupon application.
 * Each entry defines which additional flags must be enabled for coupons to apply to specific services.
 * @typedef {object} CouponRequirement
 * @property {string} serviceCode - The service code that requires additional flags
 * @property {string} requiredFlag - The experiment flag that must be enabled
 */
export const COUPON_FLAG_REQUIREMENTS = [
  {
    serviceCode: 'llc_amendment',
    requiredFlag: ENABLE_AMENDMENT_V2_JOURNEY
  },
  {
    serviceCode: 'llc_annual_report',
    requiredFlag: ENABLE_ANNUAL_REPORT_V2_JOURNEY
  }
];
